import React from 'react';

import { subscribe_path } from '../../routes';
import Button from '../BaseUI/Button';

const FooterSection = ({ isSubscriber }: { isSubscriber: boolean }) => {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-mt-24 tw-px-16 lg:tw-px-0">
      <div className="tw-font-serif tw-font-medium tw-text-headline-lg md:tw-text-headline-xl tw-text-pro-red tw-text-center">
        Read The Information first...
      </div>
      <div className="tw-font-serif tw-font-medium tw-text-headline-lg tw-text-center">
        or <span className="tw-italic">them</span> later
      </div>
      <div className="tw-font-serif tw-text-style tw-font-normal tw-body-lg tw-text-[#545B69] tw-text-center sm:tw-max-w-[520px] tw-mb-32">
        The Information is where you go to get the most important news about technology and business
        first.
      </div>
      {!isSubscriber && (
        <Button
          className="tw-mt-8 tw-mb-48 tw-w-[240px] !tw-capitalize tw-text-sans !tw-text-body-lg"
          rounded="slight"
          type="button"
          variant="primary"
          href={subscribe_path()}
        >
          Subscribe
        </Button>
      )}
    </div>
  );
};

export default FooterSection;
